import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';

const LayoutChanger = ({ open, data, handleCloseLayoutChanger }) => {
    const [visible, setVisible] = useState(open);

    const handleClose = (data) => {
        handleCloseLayoutChanger(null);
        setVisible(false);
    }

  const defaultValues = {
  textColor: data?.textColor ?? null,
  backgroundColor: data?.backgroundColor ?? null,
  text: data?.text ?? "",
  subtitle: data?.subtitle ?? null,
  type: data?.type ?? null,
  link: data?.link ?? ""
};


    const {
        control,
        formState: { errors },
        handleSubmit
    } = useForm({ defaultValues });

    const onSubmit = (data) => {
        handleCloseLayoutChanger(data);
        setVisible(false);

    };

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    return (
        <Dialog header="Change Layout" visible={visible} style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => handleClose()}>
            <div className="card">
                <form onSubmit={handleSubmit(onSubmit)} >
                    <div className="field">
                        <Controller
                            name="textColor"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Text  Color </label>
                                    </span>
                                </>
                            )}
                        />
                    </div>
                    <div className="field">
                        <Controller
                            name="backgroundColor"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Background Color</label>
                                    </span>
                                </>
                            )}
                        />
                    </div>
                    <div className="field">
                        <Controller
                            name="text"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputTextarea id={field.name} rows={4} cols={30} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Title Text</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </>
                            )}
                        />
                    </div>
                    <div className="field">
                        <Controller
                            name="subtitle"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputTextarea id={field.name} rows={4} cols={30} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Subtitle Text</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </>
                            )}
                        />
                    </div>
                    <div className="field">
                        <Controller
                            name="type"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputTextarea id={field.name} rows={4} cols={30} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Type of LP</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </>
                            )}
                        />
                    </div>
                    <div className="field">
                        <Controller
                            name="link"
                            control={control}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                    <span className="p-float-label">
                                        <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor={field.name}>Link</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </>
                            )}
                        />
                    </div>
                    <div className="flex justify-content-end">
                        <Button label="Update" type="submit" outlined />
                    </div>
                </form>
            </div>
        </Dialog>
    )
}

export default LayoutChanger